export default "__VITE_ASSET__nBlpa4ei__"